module.exports = __webpack_public_path__ + "img/icon_bg11.6a3f4fc1.png";